import React from 'react'

import classnames from 'classnames'
import Skeleton from 'react-loading-skeleton'

import MenuCardSkeleton from '../menu_item/MenuCardSkeleton'

type MenuGroupSkeletonProps = {
  columns?: number
  itemCount?: number
  showTitle?: boolean
}

const MenuGroupSkeleton = ({
  columns = 1,
  itemCount = 4,
  showTitle = true
}: MenuGroupSkeletonProps) => {
  const columnsClass = `columns${columns}`

  return (
    <div
      className='editableMenuGroupContainer'
      data-testid='menu-group-skeleton'
      aria-busy='true'
    >
      <div className='groupContainer'>
        <div className='groupWrapper'>
          {showTitle && (
            <div className='groupDetails'>
              <div className='groupName'>
                <Skeleton width={200} height={28} />
              </div>
              <div className='groupDescription'>
                <Skeleton width={300} height={20} />
              </div>
            </div>
          )}
          <div className={classnames('groupItems', columnsClass)}>
            {Array.from({ length: itemCount }).map((_, index) => (
              <div key={index}>
                <MenuCardSkeleton />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MenuGroupSkeleton
